import { render, staticRenderFns } from "./TradeForm.vue?vue&type=template&id=1a837f97&scoped=true"
import script from "./TradeForm.vue?vue&type=script&lang=js"
export * from "./TradeForm.vue?vue&type=script&lang=js"
import style0 from "./TradeForm.vue?vue&type=style&index=0&id=1a837f97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a837f97",
  null
  
)

export default component.exports